import {connect} from "react-redux"
import State from "../../models/State"
import {setSelectedSortingAction} from "../../ducks/search"
import TrackSortOption from "../../events/trackEvent/events/trackSortOption"

export const mapStateToProps = (state: State) => {
    const {
        text,
        search: {disableIcons, sorting},
    } = state

    return {
        sortOptions: sorting,
        text,
        disableIcon: disableIcons.mobileSort,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    onSelect: (value: string) => {
        dispatch(setSelectedSortingAction(value))
        TrackSortOption(value)
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
